import React from 'react';
import StickerDesigner from './StickerDesigner';

const OrderStickersPage = () => {
  return <StickerDesigner />;
};

export default OrderStickersPage; 